<template>
    <div>
        <form @submit.prevent="saveCostCenterUser">
            <div class="row">
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card">
                                <div class="card-header">
                                    <i class="fas fa-hand-holding-usd"></i>Centro de Costo
                                </div>
                                <div class="card-body">
                                    <table class="table">
                                        <tr>
                                            <th>Nombre:</th>
                                            <td>{{ cCenter.name }}</td>
                                        </tr>
                                        <tr>
                                            <th>Descripción:</th>
                                            <td>{{ cCenter.description }}</td>
                                        </tr>
                                         <tr>
                                            <th>Unidad de Negocio:</th>
                                            <td>{{ cCenter.businessUnitName }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <i class="fas fa-users"></i> Usuarios
                                        </div>
                                        <div class="col-md-8">
                                            <v-select :options="users" v-model="user">
                                                <span slot="no-options">No se encontraron registros</span>
                                            </v-select>
                                        </div>
                                        <div class="col-md-1 text-right">
                                            <button type="button" @click="addUser" class="btn btn-sm btn-success" title="Agregar Usuario"><i class="fa fa-plus"></i></button>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <table class="table table-sm">
                                        <thead>
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Email</th>
                                                <th>Perfil</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="u in userSelected" :key="u.id">
                                                <td> {{ u.fullName }}</td>
                                                <td> {{ u.email }}</td>
                                                <td>
                                                    <span class="badge badge-success ml-2" v-for="rol in u.roles" :key="rol">
                                                        {{ rol }}</span>
                                                </td>
                                                <td class="text-right"><button title="Quitar Usuario" @click="removeUser(u.code)" class="btn btn-sm btn-danger"><i class="fas fa-trash"></i></button></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <button class="btn btn-block btn-success">
                            <i class="fa fa-save"></i>
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import { Put, Get } from "../../helper/axios.js";
export default {
    data() {
        return {
            apiUrl: this.$store.getters.apiUrl,
            Get,
            Put,
            user: {},
            userSelected: []
        };
    },
    props: ["cCenter", "users", "currentUsers"],
    watch: {
        currentUsers: {
            immediate: true,
            handler(newVal) {
                // Clonamos los objetos para evitar mutación accidental de la prop
                this.userSelected = newVal.map(user => ({ ...user }));
            }
        }
    },
    methods: {
        saveCostCenterUser() {
            this.$store.commit("setLoading", true);
            this.Put(this.apiUrl + "v1/CostCenterUsers/Save/" + this.cCenter.id, this.userSelected, () => {
                this.$store.commit("setLoading", false);
                window.toastr.success('Usuarios asignados al Centro de Costo correctamente.');
                this.$emit("saveCostCenterUser");
            });
        },
        addUser(){
            if (!this.userSelected.some(u => u.code === this.user.code)) {
                this.userSelected.push({ ...this.user }); // Asegura que se copia y no se enlaza
            }
        },
        removeUser(code){
            this.userSelected = this.userSelected.filter(u => u.code !== code);
        }
    }
};
</script>
